// extracted by mini-css-extract-plugin
export default {"CancelSubscriptionContainer":"_CancelSubscriptionContainer--_1QY2","Strong":"_Strong--vdzZI","TextArea":"_TextArea--z7m_p"};